
import React, { useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import * as ActionTypes from '../actions/actionTypes'
import { useEvent } from './useEvent';

export const useAmendmentReason = ({tableName="amendmentReason",containerKey})=>{
 const {isLoading,saveForm}=useEvent(containerKey)
 const dispatch = useDispatch();
  
 const dataSource = useSelector((state) => state.Shipment.amendmentReason)

 const AddItem = useCallback(async() => {
    
        dispatch({
            type: ActionTypes.ADD_ITEM_CDS_HEADER,
            payload:{id:Date.now()},
            meta:{tableName:tableName}
        })
    
  }, [])

  const deleteItem = useCallback(async(id) => {
    try{
    
        let data=dataSource.filter(c=>c.id!=id)
        data=data.length==0 ? [{}]:data
        const response=await saveForm({[`${tableName}`]:data},true)
    
        if(response)
        dispatch({ type:ActionTypes.DELETE_ITEM_CDS_HEADER,payload:{[`${tableName}`]:[{id}]},meta:{tableName:tableName}}) 
        
     }
     catch(e){

     }
 }, [saveForm,dataSource]);

 const updateItem = useCallback((id,payload) => {
        dispatch({
            type:ActionTypes.UPDATE_ITEM_CDS_HEADER,
            id,
            payload,
            meta:{tableName:tableName}
        })
  
 }, []);

 const saveItem = useCallback(async() => saveForm({[`${tableName}`]:dataSource},false), [dataSource]);



  return React.useMemo(()=>({isLoading,AddItem,deleteItem,updateItem,saveItem, dataSource}),[isLoading,AddItem,deleteItem,updateItem,saveItem, dataSource])
}